import React, {useState} from "react";
import {MdCircle, MdModeEditOutline} from "react-icons/md";
import image1 from "assets/img/profile/Group 254.png";
import image2 from "assets/img/profile/image2.png";
import image3 from "assets/img/profile/image3.png";
import Card from "components/card";
import useAsyncEffect from "use-async-effect";
import axios from "axios";
import {useUserAuth} from "../../../../context/UserAuthContext";
import {AES, enc} from "crypto-js";
import {useNavigate} from "react-router-dom";
import CustomPagination from "../../../../components/CustomPagination/CustomPagination";

const UserDevicesSummary = () => {

  const CROMPTON_URL = process.env.REACT_APP_CROMPTON_SENZE_URL;
  const CROMPTON_ANALYTICS_URL = process.env.REACT_APP_CROMPTON_SENZE_ANALYTICS_URL;

  //const CROMPTON_URL = "https://iot.crompton.co.in:8443/PAPI/"
  //const CROMPTON_ANALYTICS_URL = "https://iot.crompton.co.in:8443/AAPI/"
  const secretKey = "cromptonssecretkey";

  let {Token, logOut, Username, accesscontrollevel} = useUserAuth();
  const decryptedValueuname = AES.decrypt(Username, secretKey).toString(enc.Utf8);
  const decryptedValue = AES.decrypt(Token, secretKey).toString(enc.Utf8);
  const navigate = useNavigate();
  let [productCatalog, setProductCatalog] = useState([])

  let [deviceInfos, setDeviceInfos] = useState([])

  const [pg, setpg] = useState(0);
  const [rpg, setrpg] = useState(3);

  function handleChangePage(event, newpage) {
    setpg(newpage);
  }

  function handleChangeRowsPerPage(event) {
    setrpg(parseInt(event.target.value, 10));
    setpg(0);
  }

  const handleLogOut = async () => {
    try {
      await logOut();
      navigate("/");
    } catch (error) {
      ////console.log(error.message);
    }
  }

  function getUserDeviceHomeRoomStats() {

    var url = CROMPTON_ANALYTICS_URL + "v1/user/normalUserStats/" + decryptedValueuname

    axios({
      method: "GET", url: url, headers: {
        Authorization: decryptedValue,
      }

    }).then((res) => {
      //console.log(res.data)
      setDeviceInfos(res.data.deviceListInfos)


    }).catch((error) => {
      //console.log(error)
      if (error.response.data.status === "401" || error.response.data.status === "403") {
        handleLogOut();
      }
    })

  }

  function getProductImageUrl(productId, productCategory) {
    const productCatalog = JSON.parse(sessionStorage.getItem("productCatalogArray"));

    // Find the first matching product and return its categoryEnUrl
    const matchingProduct = productCatalog.find(item => item.productId.includes(productId));
    if (matchingProduct) {
      if(matchingProduct.productUrl === "" || matchingProduct.productUrl === null){
        if(matchingProduct.categoryEnUrl === "" || matchingProduct.categoryEnUrl === null){
          const matchingProduct = productCatalog.find(item => item.unit.includes(productCategory));
          if (matchingProduct) {
            return matchingProduct.categoryEnUrl;
          }
        }else{
          return matchingProduct.categoryEnUrl
        }
      }else{
        return matchingProduct.productUrl;
      }

    } else {
      if(productCategory.includes("Light")){
        return "https://iot.crompton.co.in/CDN/img/catalog/catagory/ic_cat_grey_lighting.png"
      }else if(productCategory.includes("Pump")){
        return "https://iot.crompton.co.in/CDN/img/catalog/catagory/ic_cat_grey_pumps.png"
      }else if(productCategory.includes("Fan")){
        return "https://iot.crompton.co.in/CDN/img/catalog/catagory/ic_cat_grey_fans.png"
      }else{
        return "https://iot.crompton.co.in/CDN/img/catalog/catagory/ic_cat_grey_appliances.png"
      }
      // Handle the case where no matching product is found (optional)
      //console.warn("No matching product found for category:", productCategory);
      //return image1; // Or return a default image URL
    }
  }
  /*function getProductImageUrl(productCategory) {

    const productCatalog = JSON.parse(sessionStorage.getItem("productCatalogArray"));

    // Find the first matching product and return its categoryEnUrl
    const matchingProduct = productCatalog.find(item => item.unit.includes(productCategory));
    if (matchingProduct) {
      return matchingProduct.categoryEnUrl;
    } else {
      // Handle the case where no matching product is found (optional)
      console.warn("No matching product found for category:", productCategory);
      return ""; // Or return a default image URL
    }
  }*/

  useAsyncEffect(async () => {
    setProductCatalog(JSON.parse(sessionStorage.getItem("productCatalogArray")))
        getUserDeviceHomeRoomStats()
      }, [""]
  );
  return (
    <Card extra={"w-full p-4 h-full"}>
      <div className="mb-8 w-full">
        <h4 className="text-xl font-bold text-navy-700 dark:text-white">
          User Devices
        </h4>
        <p className="mt-2 text-base text-gray-600">
          Here you can find summary about your devices.
        </p>
      </div>
      {/* Project 1 */}
      {
        deviceInfos.slice(pg * rpg, pg * rpg + rpg).map((Val) => {
              return (
                  <div className="mt-3 flex w-full items-center justify-between rounded-2xl bg-white p-3 shadow-3xl shadow-shadow-500 dark:!bg-navy-700 dark:shadow-none">
                    <div className="flex items-center">
                      <div className="">
                        <img className="h-[83px] w-[83px] rounded-lg" src={getProductImageUrl(Val.productId, Val.deviceType)} alt="" />
                      </div>
                      <div className="ml-4">
                        <p className="text-base font-medium text-navy-700 dark:text-white">
                          Device Name: <b>{Val.deviceName}</b>
                        </p>
                        <p className="mt-2 text-sm text-gray-600">
                          Category: {Val.deviceType} &nbsp;
                          <a
                              className="ml-1 font-medium text-[#0B83B5] hover:text-[#0B83B5] dark:text-white"
                          >
                            &nbsp; Room: {Val.roomName}
                          </a>
                        </p>
                      </div>
                    </div>
                    <div className="mr-4 flex items-center justify-center text-gray-600 dark:text-white">
                      {Val.status.toUpperCase() === "ONLINE" ? <MdCircle className=" text-[30px] text-green-700" /> : <MdCircle className=" text-[30px] text-[#6E6E6E]"/>}

                    </div>
                  </div>
              )
            }
        )
      }
      <CustomPagination
          rowsPerPageOptions={[3, 5, 10]}
          component="div"
          count={deviceInfos.length}
          rowsPerPage={rpg}
          page={pg}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
      />
      {/*<div className="flex w-full items-center justify-between rounded-2xl bg-white p-3 shadow-3xl shadow-shadow-500 dark:!bg-navy-700 dark:shadow-none">
        <div className="flex items-center">
          <div className="">
            <img className="h-[83px] w-[83px] rounded-lg" src={image1} alt="" />
          </div>
          <div className="ml-4">
            <p className="text-base font-medium text-navy-700 dark:text-white">
              Technology behind the Blockchain
            </p>
            <p className="mt-2 text-sm text-gray-600">
              Project #1 .
              <a
                className="ml-1 font-medium text-brand-500 hover:text-brand-500 dark:text-white"
                href=" "
              >
                See product details
              </a>
            </p>
          </div>
        </div>
        <div className="mr-4 flex items-center justify-center text-gray-600 dark:text-white">
          <MdModeEditOutline />
        </div>
      </div>*/}
      {/* Project 1 */}
      {/*<div className="mt-3 flex w-full items-center justify-between rounded-2xl bg-white p-3 shadow-3xl shadow-shadow-500 dark:!bg-navy-700 dark:shadow-none">
        <div className="flex items-center">
          <div className="">
            <img className="h-[83px] w-[83px] rounded-lg" src={image3} alt="" />
          </div>
          <div className="ml-4">
            <p className="text-base font-medium text-navy-700 dark:text-white">
              Technology behind the Blockchain
            </p>
            <p className="mt-2 text-sm text-gray-600">
              Project #1 .
              <a
                className="ml-1 font-medium text-brand-500 hover:text-brand-500 dark:text-white"
                href=" "
              >
                See product details
              </a>
            </p>
          </div>
        </div>
        <div className="mr-4 flex items-center justify-center text-gray-600 dark:text-white">
          <MdModeEditOutline />
        </div>
      </div>*/}
      {/* Project 1 */}
      {/*<div className="mt-3 flex w-full items-center justify-between rounded-2xl bg-white p-3 shadow-3xl shadow-shadow-500 dark:!bg-navy-700 dark:shadow-none">
        <div className="flex items-center">
          <div className="">
            <img className="h-[83px] w-[83px] rounded-lg" src={image2} alt="" />
          </div>
          <div className="ml-4">
            <p className="text-base font-medium text-navy-700 dark:text-white">
              Technology behind the Blockchain
            </p>
            <p className="mt-2 text-sm text-gray-600">
              Project #1 .
              <a
                className="ml-1 font-medium text-brand-500 hover:text-brand-500 dark:text-white"
                href=" "
              >
                See product details
              </a>
            </p>
          </div>
        </div>
        <div className="mr-4 flex items-center justify-center text-gray-600 dark:text-white">
          <MdModeEditOutline />
        </div>
      </div>*/}
    </Card>
  );
};

export default UserDevicesSummary;
